import { CheckboxWithLabel as Checkbox } from '../molecules'

export default Checkbox
